import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrSemeiaIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M14.7515 7.03818L12.1866 2.46419C11.8499 1.86573 11.2317 1.5 10.5674 1.5H5.43775C4.76885 1.5 4.1507 1.86573 3.81396 2.46419L1.2491 7.03818C0.916965 7.63189 0.916965 8.36811 1.2491 8.96182L3.81396 13.5358C4.14609 14.1295 4.76424 14.5 5.43312 14.5H10.5628C11.2317 14.5 11.8499 14.1343 12.182 13.5358L14.7469 8.96182C15.0836 8.36811 15.0836 7.63189 14.7515 7.03818ZM7.53669 5.39002L8.7499 7.55589C8.90213 7.83139 8.90213 8.17337 8.7499 8.44884L7.53669 10.6147L7.47671 10.7192H7.59664H10.0277C10.5075 10.7192 10.895 11.1182 10.895 11.6122C10.895 12.1061 10.5075 12.5051 10.0277 12.5051H5.97748C5.6684 12.5051 5.38238 12.3341 5.22555 12.0587C5.07332 11.7832 5.07332 11.4412 5.22555 11.1657L6.97849 8.03562L6.99696 8.00237L6.97849 7.96914L5.22555 4.83905C5.07332 4.56358 5.07332 4.2216 5.22555 3.94611C5.37778 3.67063 5.6684 3.49963 5.97748 3.49963H10.0277C10.5075 3.49963 10.895 3.89861 10.895 4.39258C10.895 4.88655 10.5075 5.28552 10.0277 5.28552H7.59664H7.47671L7.53669 5.39002Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrSemeiaIconComponent;
